<template>
  <div class="coin hover-shadow">
    <div class="row">
      <h3 @click="goToDetails">
        {{ coinToDisplay.name }}
      </h3>
    </div>
    <div class="row">
      <img
        class="face"
        :src="coinToDisplay.images.obverse"
        alt="Image indisponible"
      >
    </div>
    <div
      v-if="isAuthenticated && coinToDisplay.docId"
      class="row buttons"
    >
      <div class="col">
        <custom-button
          style="margin-left: 0.2em"
          :loading="pending"
          :xs="true"
          @click.native="decrementAmount"
        >
          <span class="fas fa-minus"></span>
        </custom-button>
      </div>
      <div class="col input">
        <div class="row">
          <input
            v-model="coinToDisplay.amount"
            class="field"
            type="text"
            readonly
          >
        </div>
      </div>
      <div class="col">
        <custom-button
          style="margin-right: 0.2em"
          :loading="pending"
          :xs="true"
          @click.native="incrementAmount"
        >
          <span class="fas fa-plus"></span>
        </custom-button>
      </div>
    </div>
    <div
      v-if="isAuthenticated && !coinToDisplay.docId"
      class="row buttons"
    >
      <custom-button @click.native="addToMyCollection">
        Ajouter
      </custom-button>
    </div>
    <div
      v-if="!isAuthenticated"
      class="row"
    ></div>
  </div>
</template>

<script>
  import CustomButton from './micro-components/custom-button';
  import FirebaseCollection from './../tools/FirebaseCollection';
  import store from './../stores';

  export default {
    name: 'CollectionItem',
    components: { CustomButton },
    props: ['coin'],
    data() {
      return {
        coinToDisplay: null,
        pending: false,
      };
    },
    computed: {
      isAuthenticated() {
        return store.state.auth.isAuthenticated;
      },
    },
    created() {
      this.coinToDisplay = this.getCoin(this.coin);
    },
    methods: {
      goToDetails() {
        this.$router.push({ name: 'details', params: { id: this.coin.id } });
      },
      async incrementAmount() {
        this.pending = true;
        await FirebaseCollection.increaseAmountOfCoin(this.coinToDisplay);
        this.coinToDisplay = this.getCoin(this.coinToDisplay);
        this.pending = false;
      },
      async decrementAmount() {
        this.pending = true;
        await FirebaseCollection.decreaseAmountOfCoin(this.coinToDisplay);
        this.coinToDisplay = this.getCoin(this.coinToDisplay);
        this.pending = false;
      },
      async addToMyCollection() {
        this.pending = true;
        await FirebaseCollection.addCoinFromList(this.coinToDisplay.id);
        this.coinToDisplay = this.getCoin(this.coinToDisplay);
        this.pending = false;
      },
      getCoin({ id, docId }) {
        let storedCoin;
        if (docId) {
          storedCoin = store.getters.getCoinByDocId(docId);
        } else {
          storedCoin = store.getters.getCoinById(id);
        }
        return storedCoin || this.coin;
      }
    },
  };
</script>

<style scoped>
    h3 {
        margin-top: 0;
        margin-bottom: 0.5em;
        cursor: pointer;
    }

    .coin {
        margin: 1em;
        display: flex;
        flex-flow: column;
        justify-content: space-between;
        border: 1px solid darkorange;
        border-radius: 5px;
        text-align: center;
        min-height: 75px;
        width: 180px;
    }

    .face {
        max-height: 125px;
        max-width: 125px;
        height: auto;
    }

    .row {
        width: 100%;
        justify-content: center;
    }

    .buttons {
        margin: 0.5em 0 0.5em 0;
        justify-content: center;
    }

    .field {
        text-align: center;
        margin: 0 4px;
    }

    .field {
        flex: 1;
    }

    .col.input {
        flex: 1;
    }

    .col.input > .row {
        margin: 0;
        height: 100%;
    }
</style>
